import templateUrl from './transportation-providers.html';
import clone from 'lodash/clone';

export const transportationProvidersComponent = {
	templateUrl,

	bindings: {
		details: '<',
		slugUrl: '@'
	},

	controller: class TransportationProvidersComponent {
		constructor(TransportationProvidersService, ApiService, $anchorScroll, $filter, DateService) {
			'ngInject';

			this.transportationProvidersService = TransportationProvidersService;
			this.apiService = ApiService;
			this.$anchorScroll = $anchorScroll;
			this.dateService = DateService;
			this.countyId = null;
			this.serviceTypeId = null;
			this.serviceAreaId = null;
		}

		$onInit() {
			this.details = this.transportationProvidersService.getProviderDetails(this.details);
			this.currentPage = 1;
			this.itemPerPage = 10;
			this.totalItems = this.details.count;

			this.filterDetails = {
				'limit': this.itemPerPage,
				'pageId': this.currentPage
			};
		}

		onChange(pageNumber) {
			this.currentPage = pageNumber;
			this.filterDetails.limit = this.itemPerPage;
			this.filterDetails.pageId = this.currentPage;
			this.transportationProvidersService.getProviderFilterData({ id: this.countyId, serviceTypeId: this.serviceTypeId, filterDetails: this.filterDetails }, this.slugUrl).then(details => {
				this.details.details = details.details;
				this.$anchorScroll(() => $location.hash());
			});
		}

		onCountyChange(ids) {
			this.countyId = ids;
			this.currentPage = 1;
			this.filterDetails.pageId = this.currentPage;
			this.transportationProvidersService.getProviderFilterData({ id: this.countyId, serviceTypeId: this.serviceTypeId, filterDetails: this.filterDetails }, this.slugUrl).then(details => {
				this.details.details = clone(details.details)
				this.totalItems = details.count;
			});
		}

		onServiceTypeChange(serviceTypeIds) {
			this.currentPage = 1;
			this.filterDetails.pageId = this.currentPage;
			this.serviceTypeId = serviceTypeIds;
			this.transportationProvidersService.getProviderFilterData({ id: this.countyId, serviceTypeId: this.serviceTypeId, filterDetails: this.filterDetails }, this.slugUrl).then(details => {
				this.details.details = clone(details.details)
				this.totalItems = details.count;
			});
		}

		_getImage(report) {
			const image = report.image;
			return image ? this.apiService.getResourceUrl(`files/images/${image}`) : '';
		}

		_getClass(type) {
			return type === 'Public Transit' ? 'publicType' : type === 'Private Transportation' ? 'privateType' : type === 'Paratransit' ? 'paraTransit' : type === 'Volunteer' ? 'volunteer' : type === 'Other' ? 'otherType' : 'noType';
		}

		_getTime(time) {
			return this.dateService.getFormattedTime(time);
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/components/transportation-providers/transportation-providers.component.js